



















































import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import UserGoal from '../../../api/v2/models/user_goal'
import api from '../../../api/v2/api'
import { headerState } from '../../stores/header'
import { debounce } from 'underscore'
import { footerState } from '../../stores/footer'
@Component({
  components: {}
})
export default class UserGoalList extends Vue {
  mobile: boolean = false
  search = ''
  userGoals: UserGoal[] = []
  breadcrumbs = [
    {
      text: 'クラスルーム',
      disabled: false,
      exact: true,
      to: '/classroom/'
    },
    {
      text: 'ゴール',
      disabled: false,
      exact: true,
      to: '/classroom/user-goals'
    }
  ]

  async created() {
    headerState.setTitle('ゴール一覧')
    footerState.setFooterDefault()
    this.userGoals = await api.userGoal.index().catch()
  }

  @Watch('search')
  watchSearch(){
    this.handleSearch(this, this.search)
  }

  handleSearch = debounce(async (context, search) => {
    context.userGoals = await api.userGoal.index({search: search}).catch()
  }, 400)
}
